import React, { useCallback, useMemo } from 'react';
import ResponsiveModal from './ResponsiveModal';
import { useGenogram } from '../../contexts/GenogramContext';
import { FamilyFinderProvider } from '../../../family-finder/context/FamilyFinderContext';
import FamilyFinderPage from '../../../family-finder/pages/FamilyFinderPage';
import childSeed from '../../../family-finder/data/seedChild';
import '../../../family-finder/styles/familyFinder.css';

const FamilyFinderDialog = () => {
  const { state, actions } = useGenogram();
  const { familyFinderOpen, selectedPerson } = state;

  const handleClose = useCallback(() => {
    actions.setFamilyFinderOpen(false);
  }, [actions]);

  const childId = useMemo(() => {
    if (selectedPerson && selectedPerson.familyFinderChildId) {
      return selectedPerson.familyFinderChildId;
    }
    return childSeed._id;
  }, [selectedPerson]);

  const title = useMemo(() => {
    if (selectedPerson) {
      return `Family Finding • ${selectedPerson.name}`;
    }
    return 'Family Finding';
  }, [selectedPerson]);

  if (!familyFinderOpen) {
    return null;
  }

  return (
    <ResponsiveModal
      isOpen={familyFinderOpen}
      onClose={handleClose}
      title={title}
      maxWidth="1200px"
      fullScreenOnMobile
      style={{ maxHeight: '90vh' }}
    >
      <div className="family-finder-modal">
        <FamilyFinderProvider key={childId} childId={childId}>
          <FamilyFinderPage />
        </FamilyFinderProvider>
      </div>
      <style>{`
        .family-finder-modal {
          min-height: 70vh;
        }
        .family-finder-modal .family-finder-shell {
          min-height: auto;
          padding: 1rem;
          gap: 1rem;
        }
        .family-finder-modal .family-finder-main-grid,
        .family-finder-modal .family-finder-lower-grid {
          grid-template-columns: minmax(0, 1fr);
        }
        .family-finder-modal .family-finder-genogram-panel,
        .family-finder-modal .family-finder-roster,
        .family-finder-modal .family-finder-search,
        .family-finder-modal .family-finder-contact,
        .family-finder-modal .family-finder-audit {
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
        }
        @media (min-width: 1200px) {
          .family-finder-modal .family-finder-main-grid {
            grid-template-columns: minmax(0, 1.4fr) minmax(320px, 1fr);
          }
        }
      `}</style>
    </ResponsiveModal>
  );
};

export default FamilyFinderDialog;
